module.exports = __webpack_public_path__ + "img/customer-icon-1.380453fa.png";